query PaymentsList($page: Int, $rowsPerPage: Int, $filter: JSON) {
  payments(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      platformId
      organizationId
      status
      provider
      amount {
        value
        currency
        valueUSD
      }
      ottkitFeeAmount {
        valueUSD
      }
      organizationAmount {
        valueUSD
      }
      createdAt
      organization {
        title
      }
    }
  }
}
